import {
  FETCH_APPLICATION_CENTER_DOCUMENTS,
  FETCH_APPLICATION_CENTER_DOCUMENTS_FAILURE,
  FETCH_APPLICATION_CENTER_DOCUMENTS_SUCCESS,
  SUBMIT_APPLICATION_CENTER_DOCUMENTS,
  SUBMIT_APPLICATION_CENTER_DOCUMENTS_FAILURE,
  SUBMIT_APPLICATION_CENTER_DOCUMENTS_SUCCESS,
} from './actions';
import { APPLICATION_CENTER } from './type';

export const INITIAL_STATE: APPLICATION_CENTER.IApplicationCenterReducer = {
  isLoading: 0,
  error: {} as APPLICATION_CENTER.Error,
  documents: {} as APPLICATION_CENTER.IDocumentManagement,
};

const applicationCenterReducer = (
  action: IAction,
  state = INITIAL_STATE
): APPLICATION_CENTER.IApplicationCenterReducer => {
  switch (action.type) {
    case FETCH_APPLICATION_CENTER_DOCUMENTS:
      return { ...state, isLoading: state.isLoading + 1, error: {} };

    case FETCH_APPLICATION_CENTER_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {},
        documents: action.payload,
      };

    case FETCH_APPLICATION_CENTER_DOCUMENTS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { getDocuments: action.payload },
      };
    case SUBMIT_APPLICATION_CENTER_DOCUMENTS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case SUBMIT_APPLICATION_CENTER_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        documents: action.payload,
        error: {},
      };
    case SUBMIT_APPLICATION_CENTER_DOCUMENTS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { addDocuments: action.payload.message },
      };
    default:
      return state;
  }
};

export default applicationCenterReducer;
